import { MusicType } from "../types/types";

const PLAY_MUSIC = "player/PLAY_MUSIC";

export type InitialStateType = typeof initialState

let initialState = {
  isPlaying: false,
  url: "",
  title: "",
  music: [
    {
      title: "AL-90 - Black Sapphire",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/AL-90%20-%20Black%20Sapphire.flac",
    },
    {
      title: "Andy Stott - Never the right time",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Andy%20Stott%20-%20Never%20the%20right%20time.flac",
    },
    {
      title: "Autechre - Further",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Autechre%20-%20Further.mp3",
    },
    {
      title: "Balladur - Time Is A Killing Machine",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Balladur%20-%20Time%20Is%20A%20Killing%20Machine.mp3",
    },
    {
      title: "Blue October - All That We Are",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Blue%20October%20-%20All%20That%20We%20Are.flac",
    },
    {
      title: "Bluestaeb - Didn't Cha Know",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Bluestaeb%20-%20Didn't%20Cha%20Know.mp3",
    },
    {
      title: "BLVCK CEILING - End of Time",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/BLVCK%20CEILING%20-%20END%20OF%20TIME.mp3",
    },
    {
      title: "Boards of Canada - An Eagle In Your Mind",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Boards%20Of%20Canada%20-%20An%20Eagle%20In%20Your%20Mind.flac",
    },
    {
      title: "Bowery Electric - Coming Down",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Bowery%20Electric%20-%20Coming%20Down.flac",
    },
    {
      title: "Burial - Distant Lights",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Burial%20-%20Distant%20Lights.flac",
    },
    {
      title: "Burial - Pirates",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Burial%20-%20Pirates.flac",
    }, {
      title: "CHVRCHES - Violent Delights",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/CHVRCHES%20-%20Violent%20Delights.flac",
    }, {
      title: "Cold Cave - Glory",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Cold%20Cave%20-%20Glory.mp3",
    },
    {
      title: "Cremation Lily - Lovers Against the Rocks",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Cremation%20Lily%20-%20Lovers%20Against%20the%20Rocks.mp3",
    },
    {
      title: "Doja Cat - 4 mordant",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Doja%20Cat%20-%204%20Morant.mp3",
    },
    {
      title: "Felix Da Housecat - Everyone Is Someone In LA",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Felix%20Da%20Housecat%20-%20Everyone%20Is%20Someone%20In%20LA.mp3",
    },
    {
      title: "Frank Knight - Awakened",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Frank%20Knight%20-%20Awakened.mp3",
    },
    {
      title: "Fraunhofer Diffraction - Bloodlust",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Fraunhofer%20Diffraction%20-%20Bloodlust.mp3",
    },
    {
      title: "Fuel - Halos Of The Sun",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Fuel%20-%20Halos%20of%20the%20Sun.mp3",
    },
    {
      title: "Gopinatha - Primeval Lord",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Gopinatha%20-%20Primeval%20Lord.mp3",
    },
    {
      title: "Grimes - Flesh without Blood",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Grimes%20-%20Flesh%20without%20Blood.flac",
    },
    {
      title: "Jamie xx - Far Nearer",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Jamie%20xx%20-%20Far%20Nearer.mp3",
    },
    {
      title: "Jazzpospolita - Czerwona Flaga (Ale Ja Sie Kapie)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Jazzpospolita%20-%20Czerwona%20Flaga%20(Ale%20Ja%20Sie%20Kapie).mp3",
    }, {
      title: "Joell Ortiz feat. Jadakiss & Saigon - Hip Hop (Remix)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Joell%20Ortiz%20feat.%20Jadakiss%20%26%20Saigon%20-%20Hip%20Hop%20(Remix).mp3",
    },
    {
      title: "Lissy Trullie - Madeleine (Jewellers Remix)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Lissy%20Trullie%20-%20Madeleine%20(Jewellers%20Remix).mp3",
    },
    {
      title: "Lorn - Acid Rain",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Lorn%20-%20Acid%20Rain.flac",
    }, {
      title: "Lorn - BITTER ARCS",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Lorn%20-%20BITTER%20ARCS.flac",
    }, {
      title: "Lorn - PERFEKT DARK",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Lorn%20-%20PERFEKT%20DARK.flac",
    }, {
      title: "Muse - Undisclosed Desires",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Muse%20-%20Undisclosed%20Desires.flac",
    },
    {
      title: "Nadja - Long Dark Twenties",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Nadja%20-%20Long%20Dark%20Twenties.mp3",
    },
    {
      title: "Natalie Merchant - San Andreas Fault",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Natalie%20Merchant%20-%20San%20Andreas%20Fault.mp3",
    }, {
      title: "Nine Inch Nails - Terrible Lie (live)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Nine%20Inch%20Nails%20-%20Terrible%20Lie%20(live).mp3",
    }, {
      title: "Omni Trio - First Contact",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Omni%20Trio%20-%20First%20Contact.mp3",
    },
    {
      title: "P E A C E A N D T R A N Q U I L I T Y - A Hat In Time (Seal The Deal DLC)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/P%20E%20A%20C%20E%20A%20N%20D%20T%20R%20A%20N%20Q%20U%20I%20L%20I%20T%20Y%20-%20A%20Hat%20In%20Time%20(Seal%20The%20Deal%20DLC).mp3",
    },
    {
      title: "Pale Saints - Porpoise",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Pale%20Saints%20-%20Porpoise.mp3",
    },
    {
      title: "Pastel Ghost - Pulse",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Pastel%20Ghost%20-%20Pulse.flac",
    },

    {
      title: "Thom Yorke - Hearing Damage",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Thom%20Yorke%20-%20Hearing%20Damage.flac",
    },
    {
      title: "STARFORCE - Age of Nano",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/STARFORCE%20-%20Age%20of%20Nano.flac",
    },
    {
      title: "Sendelica - It's the Neu! Kosmiche Disko",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Sendelica%20-%20It's%20the%20Neu%20Kosmiche%20Disko.mp3",
    },
    {
      title: "Shlohmo - We Sat in the Car",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Shlohmo%20-%20We%20Sat%20in%20the%20Car.flac",
    },
    {
      title: "Shlømo - Ivory",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Shl%C3%B8mo%20-%20Ivory.mp3",
    },
    {
      title: "Whirr - Sway",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Whirr%20-%20Sway.flac",
    },
    {
      title: "Yves Tumor feat. James K - Licking An Orchid (feat. James K)",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/Yves%20Tumor%20feat.%20James%20K%20-%20Licking%20An%20Orchid%20(feat.%20James%20K).flac",
    },
    {
      title: "Планета Плутон - Тишина",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/%D0%9F%D0%BB%D0%B0%D0%BD%D0%B5%D1%82%D0%B0%20%D0%9F%D0%BB%D1%83%D1%82%D0%BE%D0%BD%20-%20%D0%A2%D0%B8%D1%88%D0%B8%D0%BD%D0%B0.mp3",
    }, {
      title: "Электрофорез - Русская принцесса",
      url: "https://raw.githubusercontent.com/cththes/Social-Network-Database/master/Music/%D0%AD%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D1%84%D0%BE%D1%80%D0%B5%D0%B7%20-%20%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%B0%D1%8F%20%D0%BF%D1%80%D0%B8%D0%BD%D1%86%D0%B5%D1%81%D1%81%D0%B0.mp3",
    },
  ] as Array<MusicType>,
};

const playerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PLAY_MUSIC:
      if (state.isPlaying && state.url !== action.url) state.isPlaying = false;
      return {
        ...state,
        url: action.url,
        title: action.title,
        isPlaying: !state.isPlaying,
      };
    default:
      return state;
  }
};

export const playMusicActionCreator = (currentTrack: MusicType) => ({
  type: PLAY_MUSIC,
  url: currentTrack.url,
  title: currentTrack.title,
});

export default playerReducer;
